import { MUSIC_LIBRARY } from '../configs/media/musicLibrary';
export function getAllSongs() {
    return MUSIC_LIBRARY.artists.flatMap((artist) => artist.albums.flatMap((album) => album.songs));
}
export function getSongWithContextById(id) {
    for (const artist of MUSIC_LIBRARY.artists) {
        for (const album of artist.albums) {
            for (const song of album.songs) {
                if (song.id === id)
                    return { song, album, artist };
            }
        }
    }
    return null;
}
export function getSongMetadata(id) {
    const context = getSongWithContextById(id);
    if (!context) {
        return {
            title: id,
            artist: 'Unknown Artist',
            album: 'Unknown Album',
            year: 2025,
            lyrics: false,
            game: 'none',
            duration: 180,
            albumImageUrl: undefined,
        };
    }
    const { song, album, artist } = context;
    return {
        title: song.title,
        artist: artist.name,
        album: album.name,
        albumImageUrl: album.coverImage,
        year: album.year,
        lyrics: song.lyrics,
        game: song.game,
        duration: song.duration,
    };
}
//# sourceMappingURL=getMusic.js.map